import { useEffect, useState } from 'react';
import ReactAudioPlayer from 'react-audio-player';
import { Download } from '../../controller/FileController';

export function AudioWithDownload({ attachmentId }: { attachmentId: string }) {
  const [audioSrc, setAudioSrc] = useState<string | null>(null);

  const returnDowload = async () => {
    const response = await Download(attachmentId);
    return URL.createObjectURL(response);
  };

  useEffect(() => {
    async function fetchAudioSrc() {
      try {
        const response = await returnDowload();
        setAudioSrc(response);
      } catch (error) {
        setAudioSrc(null);
      }
    }

    fetchAudioSrc();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [attachmentId]);

  if (!audioSrc) {
    return <p>Carregando áudio...</p>;
  }

  return <ReactAudioPlayer src={audioSrc} autoPlay={false} controls />;
}
